export default __webpack_public_path__ + "static/media/AKM_5.79683cb3.png";